import React from "react";
import {
  Container,
  Col,
  Navbar as BootstrapNavbar,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import { FormattedMessage } from "react-intl";
import LanguageSwitcher from "./LanguageSwitcher";
import styled from "styled-components";
import C from "../../colors";
import LocalizedLink from "../components/localizedLink";
import Search from "../components/Search";

const searchIndices = [
  { name: `EOSGo_Blog_prod`, title: `BLOG POSTS`, hitComp: `BlogPostHit` },
  { name: `EOSGo_News_prod`, title: `NEWS POSTS`, hitComp: `NewsPostHit` },
];

const NavbarSpacer = styled.div`
  height: 80px;
`;
const StyledNavbar = styled.div`
  .collapse {
    visibility: visible;
  }

  margin: 0 -15px;
  margin-right: -20px;

  @media (max-width: 768px){
    margin: 0 0;
  }

  .logo-link {
    cursor: pointer;
    // margin-left: -2.3em !important;
  }

  a.localeButton {
    color: ${C.gray};
    &:hover {
      color: ${C.light};
    }
  }

  a {
    color: ${C.THEME ? C.lightgreen : C.dark};
    // margin-right: 20px;
    font-weight: bold;
    display: inline-block;
    vertical-align: top;

    &.active {
      // text-decoration: underline;
      border-bottom: 2px solid;
    }
    &:hover {
      text-decoration: none;
      color: ${C.THEME ? 'white' : C.dark};
    }
  }

  .highlight a {
    padding: 4px 10px;
    border: 1px solid;
    border-radius: 4px;
  }

  background: none;
  padding: 0;
  margin-bottom: 0.1rem !important;
  &.narrow-nav {
    margin-bottom: 0;
    .navbar {
      border-bottom: none;
      padding: 20px 0;
    }
  }
  &.sticky-nav {
    position: fixed;
    z-index: 100;
    background: white;
    width: 100%;
    top: 0;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
  }

  .navbar {
    padding: 30px 0 20px;
    border-bottom:none;
    width: 100%;
    display: flex;
    flex-wrap: no-wrap;
    align-items: center;
    justify-content: space-between;
  }

  .navbar-nav {
    margin-right: 0;
    margin-left: auto;
    text-align: right;
  }
  amp-sidebar .navbar-nav {
    .nav-item {
      display: block;
      padding-left: 40px;
      padding-right: 40px;
      text-align: left;
      line-height: 40px;
      &:last-child {
        padding-right: 40px;
      }
    }
  }

  .navbar-brand,
  .navbar-light .navbar-brand {
    color: ${C.purple};
    &:hover {
      color: ${C.purple};
    }

    ${C.fontFamilyBrandon};
    text-transform: uppercase;
    font-weight: bold;
    font-size: 17px;
  }
  .navbar-label {
    vertical-align: middle;
  }

  .navbar-nav {
    @media (max-width: 770px){
        margin-top:15px !important;
      }
    color: ${C.grayDark2};
    vertical-align: middle;
    display: block;
    .nav-link {
      // Increase click area
      padding: 5px;
      margin: -5px;
    }
    .nav-item {
      display: inline-block;
      vertical-align: middle;
      font-weight: bold;
      font-size: 14px;
      padding-left: 40px;
      @media (max-width: 1180px) {
        padding-left: 30px;
      }
      @media (max-width: 1080px) {
        padding-left: 20px;
      }
      @media (max-width: 980px) {
        padding-left: 15px;
      }
      /* a:not(.btn) {
        color: inherit;
        &:hover {
          color: ${C.purpleLight};
        }
      } */
    }
  }

  img.navbar-logo {
    max-height: 25px;
    margin: 0 4px;
    display: inline;
  }
  .mobile-show {
    display: none;
  }

  //////////////////////////////////
  // SMALL SCREENS
  //////////////////////////////////

  @media only screen and (max-width: 767px) {
    margin-bottom: 30px;
    .mobile-hidden {
      display: none;
    }
    .mobile-show {
      display: block;
    }
  }
  @media only screen and (max-width: 442px) {
.spacer-search{
  margin-top:20px;
}
  }

  @media only screen and (max-width: 406px) {
    .spacer{
  margin-top:15px;
}
  }

`;

// Web/AMP/MIP compatible menu
class CompatibleMenu extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { ampMode, isOpen, onClick, children } = this.props;
    if (ampMode === "none") {
      return [
        <NavbarToggler onClick={onClick} />,
        <Collapse isOpen={isOpen} navbar>
          {children}
        </Collapse>,
      ];
    } else if (ampMode === "amp") {
      return [
        <NavbarToggler on="tap:sidebar1.toggle" />,
        <amp-sidebar id="sidebar1" layout="nodisplay" side="right">
          <div
            role="button"
            aria-label="close sidebar"
            on="tap:sidebar1.toggle"
            tabindex="0"
            class="close-sidebar"
          >
            ✕
          </div>
          {children}
        </amp-sidebar>,
      ];
    } else if (ampMode === "mip") {
      return [
        <NavbarToggler on="tap:sidebar1.toggle" />,
        <mip-sidebar
          id="sidebar1"
          layout="nodisplay"
          side="right"
          className="mip-hidden"
        >
          {children}
        </mip-sidebar>,
      ];
    }
  }
}
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }
  renderNavItems() {
    return (
      <>
        {/* <NavItem key="menu-marketcap">
          <LocalizedLink
            to="/marketcap/"
            activeClassName="active"
            className="marketcap-link"
          >
            <FormattedMessage id="menu-marketcap" />
          </LocalizedLink>
        </NavItem> */}
        <NavItem key="menu-news">
          <LocalizedLink to="/news" activeClassName="active">
            <FormattedMessage id="menu-news" />
          </LocalizedLink>
        </NavItem>
        <NavItem key="menu-blog">
          <LocalizedLink to="/blog" activeClassName="active">
            <FormattedMessage id="menu-blog" />
          </LocalizedLink>
        </NavItem>
        <NavItem key="menu-eden" className="highlight">
          <LocalizedLink to="/eden" activeClassName="active">
            <FormattedMessage id="Eden Guide" />
          </LocalizedLink>
        </NavItem>
      </>
    );
  }

  render() {
    const { ampMode, sticky, contentfulID, locale } = this.props;

    const isAmp = ["amp", "mip"].indexOf(ampMode) > -1;

    return (
      <React.Fragment>
        {sticky && <NavbarSpacer />}
        <StyledNavbar className={sticky ? "sticky-nav narrow-nav" : ""}>
          <BootstrapNavbar color="transparent" light expand="md">
            <LocalizedLink to="/">
              {!isAmp && (
                <img
                  className="logo-link"
                  src="/img/logo-dark.png"
                  alt="EOS Go Logo"
                  style={{ width: 140 }}
                />
              )}
              {isAmp && (
                <img
                  className="logo-link"
                  src="/img/logo-dark.png"
                  alt="EOS Go Logo"
                />
              )}
            </LocalizedLink>

            <CompatibleMenu
              onClick={this.toggle}
              isOpen={this.state.isOpen}
              ampMode={ampMode}
            >
              <Nav className="ml-auto" navbar>
                {/* this is the menu links section */}
                {this.renderNavItems()}
                <NavItem key="menu-locale">
                  <div className="spacer"></div>
                  <LanguageSwitcher
                    className="language-switcher"
                    contentfulID={contentfulID}
                    locale={locale}
                  />
                </NavItem>
                {/* showing this only if AMP */}

                {!isAmp && (
                  <NavItem key="menu-search">
                    <div className="spacer-search"></div>
                    <Search collapse indices={searchIndices} />
                  </NavItem>
                )}

                {/* <NavItem>
                  <Button
                      color="primary"
                      href="https://www.strikingly.com/s?utm_source=nav&utm_medium=blog"
                    >
                      {" "}
                      Log In to Strikingly{" "}
                    </Button>
                </NavItem> */}
              </Nav>
            </CompatibleMenu>
          </BootstrapNavbar>
        </StyledNavbar>
      </React.Fragment>
    );
  }
}

export default Navbar;
